/**
 * Figma (`Net new - Year over year campaigns`, node `10436:4688`): the nested panel starts 12px to the
 * right of the row that opens it, its top level with that row's.
 */
export const SUBMENU_OFFSET = 12;

/** The row's trailing chevron, a size smaller than the leading icon, as in the sidebar's own rows. */
export const SUBMENU_CHEVRON_SIZE = 16;
